import React, { useState, useContext } from "react";
import ForgotPassword from "../login/ForgotPassword";
import { Account } from "../login/Account";
export const PasswordPage = () => {
    return (
        <div>
            <Account>
                <ForgotPassword />
            </Account>
        </div>
    );
};
